<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 180px;" class="ml-1">
								<v-select :items="selectCourseList" v-model="query.courseId" item-text="courseName"
									item-value="id" label="课程名" dense outlined clearable></v-select>
							</div>
							<div style="width: 150px;" class="ml-1">
								<v-text-field clearable dense label="班级名称" outlined v-model="query.className">
								</v-text-field>
							</div>
							<div style="width: 130px;" class="ml-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
											dense outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 130px;" class="ml-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
											dense  outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 110px;" class="ml-1">
								<v-select :items="statusItems" v-model="query.status" item-text="statusName"
									item-value="id" label="状态" dense outlined></v-select>
							</div>
							<div style="width: 130px;" class="ml-1">
								<v-text-field clearable dense label="余课>=" outlined v-model="query.minLessonCount">
								</v-text-field>
							</div>
							<div style="width: 130px;" class="ml-1">
								<v-text-field clearable dense label="余课<=" outlined v-model="query.maxLessonCount">
								</v-text-field>
							</div>
							<v-btn @click="queryClicked" color="primary" class="ml-2">查询</v-btn>
						</v-col>
						
						
					</v-row>
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-3">
							<v-btn small @click="createClass.show=true" color="info">开班排课</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				
				<!-- 表格内容区 -->
				<template v-slot:body="{ items }">
					<tbody>
					  <tr v-for="(item,index) in items" :key="item.id" :class="index % 2 == 0?'tr_one':'tr_two'">
						<td>{{ item.courseName }}</td>
						<td>
							<span v-if="item.consumeType=='1'">{{ consumeTypeName(item.consumeType) }}</span>
							<span v-if="item.consumeType=='2'" style="color:#E65100">{{ consumeTypeName(item.consumeType) }}</span>
						</td>
						<td>
							{{ item.className }}
						</td>
						<td>
							<span>{{ item.teacherName }}</span>
							
						</td>
						<td>
							<template>
								<span>{{item.secondTeacherName}} {{item.thirdTeacherName}}</span>
							</template>
						</td>
						<td>{{ item.roomName }}</td>
						<td width="200px">
							<div class="mt-1 mb-3">
								<v-chip small v-for="(plan,idx) in item.timePlanList" color="teal lighten-4" :key="idx" class="mt-2">
									{{plan.weekName}} {{plan.timeFrom}} - {{plan.timeTo}}
								</v-chip>
							</div>
						</td>
						<td>{{ classStatusName(item.status) }}</td>
					
						<td>{{ item.studentQty }}</td>
						<td>{{item.totalTimes}}</td>
						<td>{{item.approvedTimes}}</td>
					
						<td align="center">
							<v-btn color="teal lighten-1" @click="showDetail(item)" dark small width="80px" height="30px">班级详情</v-btn>
						</td>
					  </tr>
					</tbody>
				</template>
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		

		<!-- 班级详情页 -->
		<classDetail :show="detail.show" :classId="detail.classId" @cancel="detail.show=false"></classDetail>
		
		<!-- 开班排课组件 -->
		<createClass :show="createClass.show" @cancel="createClass.show=false" @success="createClassSuccess"></createClass>
		
	</v-card>
</template>

<script>
	import global from '../../../config/global'
	import utils from '../../../config/utils'
	import createClass from "../../../components/create_class.vue"
	import classDetail from "../../../components/class_detail.vue"
	export default {
		name: "class-list",
		components:{classDetail,createClass},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				menu3: false, // 上课时间menu
				menu4: false, // 下课时间menu
				menu5: false, // 开课日期menu
				imgPrev: global.config.imgPre,
				itemIndex:0,
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '班级管理',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '扣费方式',
							value: 'consumeType',
							sortable: false
						},
						{
							text: '班级名称',
							value: 'className',
							sortable: false
						},
						{
							text: '主课老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '助教老师',
							value: 'secondTeacherName',
							sortable: false
						},
						{
							text: '教室',
							value: 'roomName',
							sortable: false
						},
						{
							text: '上课时间',
							value: 'timePlanList',
							sortable: false,
							width:"100px"
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '学员数',
							value: 'studentQty',
							sortable: false
						},
						{
							text: '总课次',
							value: 'totalTimes',
							sortable: false
						},
						{
							text: '已上课次',
							value: 'approvedTimes',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},	
				selectCourseList: [], //选择课程数据源
				statusItems:[
					{id:"",statusName:"全部"},
					{id:"1",statusName:"正常"},
					{id:"0",statusName:"停用"},
				],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					className: "",
					status:"1",
					courseId:"",
					minLessonCount:"",
					maxLessonCount:""
				},
				detail:{
					// 详情页组件
					show:false,
					classId:""
				},
				createClass:{
					show:false
				}
			}
		},
		created() {
			
			// 接收传入的剩余课次
			let minCount = this.$route.query.minLessonCount;
			let maxCount = this.$route.query.maxLessonCount;
			if (minCount&&maxCount){
				this.query.minLessonCount = minCount;
				this.query.maxLessonCount = maxCount;
			}
			
			console.log("minCount,maxCount",minCount,maxCount);
			
			this.getTableDataList();
			this.getCourseListForSelect();
			
			
		},
		methods: {
			consumeTypeName(state){
				let stName = "未知";
				if (state === "1") {
					stName = "按课时扣费";
				} else if (state === "2") {
					stName = "按金额扣费";
				}
				return stName;
			},
			consumeTypeColor(state){
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				}
				
				return color;
			},
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},

			showDetail(item){
				this.detail.show = true;
				this.detail.classId = item.id;
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/edu/class/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.className) {
					url += "&className=" + this.query.className;
				}
				
				if (this.query.status){
					url += "&status="+this.query.status;
				}
				if (this.query.courseId){
					url += "&courseId="+this.query.courseId;
				}
				if (this.query.minLessonCount){
					url += "&minLessonCount="+this.query.minLessonCount;
				}
				if (this.query.maxLessonCount){
					url += "&maxLessonCount="+this.query.maxLessonCount;
				}
				
				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			classStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "停用";
				}
				return stName;
			},
			classStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			createClassSuccess(){
				this.createClass.show= false;
				this.getTableDataList();
			},
			getCourseListForSelect() {

				const shopId = utils.getCurrentShopId();
				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/course/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		}
	}
</script>


